import $ from 'jquery';

let mobileMenu;
let body;

const initMenuTriggers = function() {
	$('[data-menu-trigger]').on('click',function() {
		if(body.hasClass('menu-triggered')) return;
		body.addClass('menu-triggered');
		if(body.hasClass('menu-open')) {
			closeMenu();
		} else {
			openMenu();
		}
		setTimeout(function() {
			body.removeClass('menu-triggered');
		},400);
	});
    $('[data-close-menu]').on('click',closeMenu);
}

const openMenu = function() {
	body.addClass('menu-open');
	setTimeout(function() {
		body.addClass('menu-show');
	},10);
}

const closeMenu = function() {
	body.removeClass('menu-show');
    mobileMenu.find('li.menu-item-has-children.active').trigger('toggle.submenu');
	setTimeout(function() {
		body.removeClass('menu-open');
	},400);

}

const initSubmenuTriggers = function() {
    mobileMenu.find('.menu-arrow').on('click',function(e) {
        var li = $(this).closest('li').trigger('toggle.submenu');
        li.siblings().filter('.active').trigger('toggle.submenu');
    });
    mobileMenu.find('li.menu-item-has-children').on('toggle.submenu',function(e) {
        var li = $(this);
        var sub = li.find('ul.sub-menu');
        if(li.hasClass('active')) {
            sub.slideUp();
        } else {
            sub.slideDown();
        }
        li.toggleClass('active');
    });
}

export default {
	init: function() {
		body = $('body');
        mobileMenu = $('.mobile-menu');
		initMenuTriggers();
        initSubmenuTriggers();

        body.on('click',function(event) {
            var t = $(event.target).closest('.mobile-menu,[data-menu-trigger]');
            if(body.hasClass('menu-open') && !t.length) {
                closeMenu();
            }
        });

        mobileMenu.on('click','a[href^="#"]', () => {
            closeMenu();
        })
	},
	close: function() {
		closeMenu();
	},
	open: function() {
		openMenu();
	},
}
